import {Button, Flex, Modal} from "antd";
import {useState} from "react";
import {NewVisusModal} from "../NewVisusModal/NewVisusModal";
import {Patient} from "../../../models/Patient";
import {UploadFilesModal} from "../../Common/UploadFileModal/UploadFilesModal";
import {AttachmentType} from "../../../models/Practice/PracticeFIle";
import {CambioVisusFormData, UploadCambioVisusRequest} from "../../../models/cambioVisus";
import {PracticesHttpService} from "../../../services/Http/PracticesHttpService";
import {useParams} from "react-router-dom";
import {PracticeDetail} from "../../../models/Practice/PracticeDetail";

export interface CambioVisusModalProps{
    practiceDetail: PracticeDetail;
    patient?:Patient,
    isLoaded: boolean;
    loadFiles:()=>void;
    shopGroup: string;
    disabled:boolean,
    newVisusButtonEnabled:boolean,
    formType:CambioVisusModalType,
}

export enum CambioVisusModalType{
    CAMBIO_VISUS,
    RICETTA_OCULISTICA
}

export function CambioVisusModal(props:CambioVisusModalProps) {
    let { id } = useParams();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [showNewVisus, setShowNewVisus]= useState <boolean>(false)
    const [showUploadFiles, setShowUploadFiles]= useState <boolean>(false)

    const insuranceProvider = props.practiceDetail.insuranceProvider;

    const showModal = () => {
        if (props.disabled || props.isLoaded) {
            return;
        }
        if (insuranceProvider.code === 'GRUPPOGENERALI') {
            setShowNewVisus(true);
        } else {
            setIsModalOpen(true);
        }
    };

    const handleOk = () => {
        setIsModalOpen(false);
        setShowNewVisus(false);
    };

    const handleCancel = () => {
        setShowNewVisus(false);
        setShowUploadFiles(false);
        props.loadFiles()
        setTimeout(() => {
            setIsModalOpen(false);
        }, 200)
    };

    const newVisus = () => {
        setIsModalOpen(false);
        setShowNewVisus(true);
    };

    const onClickOpenUpload = () => {
        setIsModalOpen(false);
        setShowUploadFiles(true);
    };

    const onSubmit = async (data: CambioVisusFormData) => {
        const body: UploadCambioVisusRequest = {
            insuranceProviderId: insuranceProvider.id,
            data: data
        }
        await PracticesHttpService.saveClaimChangeVisus(body, id);
    }

    const getTitle = ()=>{
        if(props.formType === CambioVisusModalType.RICETTA_OCULISTICA)
            return "Ricetta oculistica";
        else
            return "Cambio visus";
    }

    const getMainButtonName = ()=>{
        if(props.formType === CambioVisusModalType.RICETTA_OCULISTICA)
            return "Ricetta Oculistica";
        else
            return "Cambio visus/Ricetta Oculistica";
    }

    return <>
        <Button disabled={props.disabled} type={"primary"} className={props.isLoaded ? "luxottica-button-success" : ""} onClick={showModal}>{getMainButtonName()}</Button>
        <Modal title={getTitle()} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
            <Flex justify={"space-around"} >
                {props.newVisusButtonEnabled ? <Button type={"primary"} onClick={newVisus}>Crea nuovo</Button> : null}
                <Button type={"primary"} onClick={onClickOpenUpload}>Carica</Button>
            </Flex>
        </Modal>
        {
            showNewVisus &&
            <NewVisusModal shopGroup={props.shopGroup} isModalOpen={showNewVisus} onSubmit={onSubmit} onCancel={handleCancel} patient={props.patient} insuranceProvider={insuranceProvider} ></NewVisusModal>
        }
        {
            <UploadFilesModal attachmentData={{
                filename:"cambio_visus.png",
                attachmentType:AttachmentType.CAMBIO_VISUS
            }} isModalOpen={showUploadFiles} onClose={handleCancel} practiceDetail={props.practiceDetail}></UploadFilesModal>
        }
    </>
}
